// @ts-strict-ignore
import {Pipe, PipeTransform} from "@angular/core";
import {SimTrainingRoomService} from "@services";
import {from, Observable} from "rxjs";
import {TrainingRoom, TrainingRoomGroup} from "@models";

@Pipe({
	name: "getTrainingRoomGroupById",
	standalone: false,
})
export class GetTrainingRoomGroupByIdPipe implements PipeTransform {
	constructor(private _simTrainingRoomService: SimTrainingRoomService) {}

	transform(value: string, ...args: unknown[]): Observable<TrainingRoomGroup> {
		if (value) {
			return from(this._simTrainingRoomService.getTrainingRoomGroupById(value));
		}
		return null;
	}
}
